/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import {colors} from "nxtconstants";

import {
  RotatingText,
  container
} from "../common";
import {WealthyEnv} from "helpers";
import {GetStartedModal} from "components/commons";

const propTypes = {
  partnerData: PropTypes.object,
  rCode: PropTypes.string,
  setToggleModal: PropTypes.func,
  toggleModal: PropTypes.bool,
  handleGetStarted: PropTypes.func
};

const GetStartedCta = ({partnerData, rCode, setToggleModal, toggleModal, handleGetStarted}) => {
  const productNames = ["Stocks", "ETF's", "Investment"];
  const isPartnerValid = partnerData?.name ? true : false;

  return (
    <>
      <GetStartedContainer>
        <GetStartedContent>
          {/* <Tagline>
            Search for&nbsp;
            <RotatingText words={productNames} />
            &nbsp;and much more
          </Tagline> */}
          <Tagline>
            Search for <ProductName>stocks</ProductName> and much more
          </Tagline>
          <CtaButton 
            onClick={handleGetStarted}
          >
            Get started
          </CtaButton>
        </GetStartedContent>
      </GetStartedContainer>
      {isPartnerValid && (
        <GetStartedModal
          rCode={rCode}
          setToggleModal={setToggleModal}
          toggleModal={toggleModal}
        />
      )}
    </>
  );
};

const GetStartedContainer = styled(container)`
  margin: 10rem auto;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: calc(50% - 1px);
    left: 0;
    height: 1px;
    width: 100%;
    background-image: repeating-linear-gradient(-2deg,#e3e3e3,#e3e3e3 5px,transparent 5px,transparent 20px,#e3e3e3 18px),repeating-linear-gradient(88deg,#e3e3e3,#e3e3e3 5px,transparent 5px,transparent 20px,#e3e3e3 18px),repeating-linear-gradient(178deg,#e3e3e3,#e3e3e3 5px,transparent 5px,transparent 20px,#e3e3e3 18px),repeating-linear-gradient(268deg,#e3e3e3,#e3e3e3 5px,transparent 5px,transparent 20px,#e3e3e3 18px);
    background-size: 1px 100%,100% 1px,1px 100%,100% 1px;
    background-position: 0 0,0 0,100% 0,0 100%;
    background-repeat: no-repeat;
    z-index: -1;
  }

  @media (max-width: 1220px) {
    padding-left: 0;
    padding-right: 0;
    margin-left: 2rem;
    margin-right: 2rem;
  }

  @media (max-width: 576px) {
    margin: 3.3rem 2rem;
    padding-bottom: 3.2rem;
  }
`;

const GetStartedContent = styled.div`
  display: flex;
  align-items: center;
  max-width: 1010px;
  margin: 0 auto;
  border-radius: 100px;
  background-color: ${colors.white};
  border: 1px solid #DDD;
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.10);
  padding: 2rem;

  @media (max-width: 576px) {
    display: block;
    border-radius: 16px;
    text-align: center;
  }
`;

const Tagline = styled.h2`
  font-size: 3.2rem;
  font-weight: 400;
  margin: 0 auto;

  @media (max-width: 576px) {
    font-size: 2.4rem;
    margin-bottom: 2.4rem;
    max-width: 240px;
  }
`;

const ProductName = styled.span`
  color: ${colors.rajah};
`;

const CtaButton = styled.a`
  font-size: 1.8rem;
  background-color: ${colors.primary};
  color: ${colors.white};
  padding: 1.7rem 4.4rem;
  display: inline-block;
  border-radius: 100px;
  transition: all 0.15s ease-in-out;
  width: 300px;
  text-align: center;
  font-weight: 700;

  &:hover {
    transform: translateY(-4px);
  }

  @media (max-width: 576px) {
    font-size: 1.6rem;
    max-width: 280px;
  }

  @media (max-width: 440px) {
    width: 240px;
  }
`;

GetStartedCta.propTypes = propTypes;

export default GetStartedCta;
